import React from 'react'
import SocialInformationForm from './SocialInformationForm'
import { Formik, Form } from 'formik'
import effects from 'app/effects/effects'
import { socialMappingToApi } from '../mapping/profileMapping'
import { useDispatch } from 'react-redux'
import MessageAlert from 'app/components/MessageAlert'
import { useIntl } from 'react-intl'
import { useFormContext, TEXT_200_MAX } from '../FormProvider'
import * as Yup from 'yup'

const validationSchema = (formatMessage) => {
  return Yup.object({
    facebookProfile: Yup.string().max(
      TEXT_200_MAX,
      formatMessage(
        { id: 'maximum.characters.allowed' },
        { limit: TEXT_200_MAX },
      ),
    ),
    lineProfile: Yup.string().max(
      TEXT_200_MAX,
      formatMessage(
        { id: 'maximum.characters.allowed' },
        { limit: TEXT_200_MAX },
      ),
    ),
    linkedinProfile: Yup.string().max(
      TEXT_200_MAX,
      formatMessage(
        { id: 'maximum.characters.allowed' },
        { limit: TEXT_200_MAX },
      ),
    ),
    twitterProfile: Yup.string().max(
      TEXT_200_MAX,
      formatMessage(
        { id: 'maximum.characters.allowed' },
        { limit: TEXT_200_MAX },
      ),
    ),
    instagramProfile: Yup.string().max(
      TEXT_200_MAX,
      formatMessage(
        { id: 'maximum.characters.allowed' },
        { limit: TEXT_200_MAX },
      ),
    ),
    ggProfile: Yup.string().max(
      TEXT_200_MAX,
      formatMessage(
        { id: 'maximum.characters.allowed' },
        { limit: TEXT_200_MAX },
      ),
    ),
    youtubeProfile: Yup.string().max(
      TEXT_200_MAX,
      formatMessage(
        { id: 'maximum.characters.allowed' },
        { limit: TEXT_200_MAX },
      ),
    ),
    otherProfile: Yup.string().max(
      TEXT_200_MAX,
      formatMessage(
        { id: 'maximum.characters.allowed' },
        { limit: TEXT_200_MAX },
      ),
    ),
  })
}
export default ({ initailValue, subscriberId, refetchData }) => {
  const dispatch = useDispatch()
  const { formatMessage } = useIntl()
  const { onSocialChange, onSocialReset } = useFormContext()

  const updateSocialInfo = (
    values,
    { resetForm, setSubmitting, setFieldError },
  ) => {
    const info = { type: 'social', payload: socialMappingToApi(values) }

    effects.apis
      .updateProfileDetailOfSubscriber({ subscriberId, info })
      .then((response) => {
        setSubmitting(false)
        onSocialReset()
        resetForm({ values })
        refetchData(subscriberId)
        dispatch(
          MessageAlert.showSuccess({
            message: formatMessage({ id: 'message.alert.success' }),
          }),
        )
      })
      .catch((error) => {
        setSubmitting(false)
        const errorCode = error?.response?.data?.details?.code
        if (errorCode === 403) {
          dispatch(
            MessageAlert.showError({
              message: formatMessage({ id: 'error.permission.denied' }),
            }),
          )
        } else if (errorCode === 618) {
          setFieldError(
            'uniqueId',
            formatMessage({ id: 'uniqueId.already.exist' }),
          )
        } else {
          dispatch(
            MessageAlert.showError({
              message: formatMessage({ id: 'message.alert.error' }),
            }),
          )
        }
      })
  }

  return (
    <div className="w-full">
      <Formik
        initialValues={initailValue}
        validationSchema={validationSchema(formatMessage)}
        onSubmit={updateSocialInfo}
      >
        <Form>
          <SocialInformationForm
            subscriberId={subscriberId}
            onSocialChange={onSocialChange}
            onSocialReset={onSocialReset}
            refetchData={refetchData}
          />
        </Form>
      </Formik>
    </div>
  )
}
